import Handsontable from 'handsontable'
import CellValue = Handsontable.CellValue
import plugins = Handsontable.plugins
import LocationService from '@/services/LocationService'

export function AutofillPlaces(
  instance: Handsontable,
  data: CellValue[][],
  coords: plugins.RangeType[]
) {
  const isPlaces = coords[0].endCol === 2
  const { startRow, endRow } = coords[0]

  if (!isPlaces) {
    return undefined
  }

  const uniquesFlatPlaces = Array.from(new Set(data.flat()))
  const russia = LocationService.getRussia()

  let currentRow = startRow
  let currentRowIndex = 0

  LocationService.getRegionsAndPlacesByPlaceNames(uniquesFlatPlaces).then(
    response => {
      while (currentRow <= endRow) {
        const currentPlaceName: string = data[currentRowIndex][0]
        const placeData = response[currentPlaceName.toLowerCase()]
        const regionCellMeta = instance.getCellMeta(currentRow, 1)
        const cityCellMeta = instance.getCellMeta(currentRow, 2)

        instance.setDataAtRowProp(currentRow, 'country.id', russia.id, 'load')
        instance.setDataAtRowProp(
          currentRow,
          'country.name',
          russia.name,
          'load'
        )

        if (placeData.states.length === 1) {
          const state = placeData.states[0]

          regionCellMeta.valid = true

          instance.setDataAtRowProp(currentRow, 'state.id', state.id, 'load')
          instance.setDataAtRowProp(
            currentRow,
            'state.name',
            state.name,
            'load'
          )
        } else {
          // Если 0 или больше 1 региона
          regionCellMeta.valid = false
        }

        if (placeData.cities.length === 1) {
          cityCellMeta.valid = true

          instance.setDataAtRowProp(
            currentRow,
            'city.id',
            placeData.cities[0].id,
            'load'
          )
          instance.setDataAtRowProp(
            currentRow,
            'city.name',
            placeData.cities[0].name,
            'load'
          )
        } else {
          // больше 1 города
          cityCellMeta.valid = false
        }

        currentRow++
        currentRowIndex++
      }

      instance.render()
    }
  )
}
